import React, { useEffect }  from 'react';
import { Typography, Grid, useMediaQuery, FormControl, TextField, Button } from '@mui/material';
import { Link, useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { useDispatch } from "react-redux"
import { useGetCartQuery, useGetUserFavoritesQuery} from '../../features/fullApi';
import { useTheme } from '@mui/material/styles';
import Error403 from '../ErrorPages/Error403'
import styled from 'styled-components';
import FavoriteItem from './FavoriteItem';
import emptyFavorite from '../Images/emptyfavorite.png'
import './favorite.css'


const MobileFavorite = styled.div`
   display: flex;
   justify-content: center;
   align-items: center;
   flex-direction: column;
   padding: 10px;
`;

const Favorite = () => {

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [])
  
  const favorite = useSelector(state => state.favorite)

  let user = useSelector(state => state.auth.user)
  if(!user) {
    user = JSON.parse(localStorage.getItem('user')) || ""
  }


  const navigate = useNavigate()

  const {data:favorites, error, isLoading} = useGetUserFavoritesQuery(user._id)


  const theme = useTheme()
  const isXs= useMediaQuery(theme.breakpoints.down('xs'));
  const isSm= useMediaQuery(theme.breakpoints.down('sm'));
  const isMd= useMediaQuery(theme.breakpoints.down('md'));
  const isLg= useMediaQuery(theme.breakpoints.down('lg'));
  const isXl= useMediaQuery(theme.breakpoints.down('xl'));




  const renderDesktopFavorite = () => (
    <div style={{width: '1200px', margin: '0 auto', minHeight: '100vh', marginTop: '122px'}}>
      <div style={{display: 'flex'}}> 
        <div style={{paddingRight:'30px', borderRight:'1px dotted #eee', width:'900px'}}>
          <div style={{display: 'flex', justifyContent: 'space-between', borderBottom: '1px solid #ddd', alignItems: 'center'}}>
            <Typography style={{textAlign: 'center'}} variant="h5" gutterBottom>Favorite products</Typography>
            <Typography style={{textAlign: 'center'}} variant="h5" gutterBottom>{favorite.favoriteTotalQuantity} items</Typography>
          </div>
          <Grid container spacing={3}>
              {favorite.favoriteItems?.map((item) => (
                  <Grid item md={12} lg={12} xl={12} xxl={12} key={item._id}>
                    <FavoriteItem item={item}/>
                  </Grid>
              ))}
          </Grid>
        </div>

      <div style={{paddingLeft:'30px', width:'260px'}}>
          <div style={{display:'flex', justifyContent:'center', alignItems:'center', borderBottom: '1px solid #ddd'}}>
            <Typography variant="h5" gutterBottom>Summary</Typography>
          </div>
          <div style={{display: 'flex', justifyContent: 'space-between', marginTop:'25px'}}>
            <Typography variant="h6" style={{marginBottom: '20px'}}>Items {favorite.favoriteTotalQuantity}</Typography>
            <Typography variant="h6" style={{marginBottom: '20px'}}>${favorite.favoriteTotalAmount}</Typography> 
          </div> 
          <br/>
        </div>  
        </div>
    </div>
  )

//   const renderTabletFavorite = () => (
//     <div style={{padding: '50px', width: '100%'}}>
//       <div style={{padding: '50px'}}>
//           <Typography style={{textAlign: 'center', padding: '50px'}} variant="h4" gutterBottom>Your Shopping Cart</Typography>
//           <Grid container spacing={3} style={{display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
//             {cart?.cartItems?.map((item) => (
//                 <Grid item key={item._id}>
//                   <FavoriteItem item={item}/>
//                 </Grid>
//             ))}
//           </Grid>
//         </div>
//     </div>
//   );

const renderMobileFavorite = () => (
  <MobileFavorite>
    <div style={{display: 'flex', justifyContent: 'center', alignItems: 'center', flexDirection: 'column'}}>
      <Typography style={{textAlign: 'center', padding: '20px'}} variant="h5" gutterBottom>My favorite</Typography>
        <Grid container spacing={3} style={{display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
          {favorite?.favoriteItems?.map((item) => (
              <Grid item key={item._id}>
                <FavoriteItem item={item}/>
              </Grid>
          ))}
        </Grid>
    </div>
    <div style={{paddingTop: '25px', width: '100%'}}>
      <Typography variant="h6" style={{paddingBottom: '25px', textAlign: 'center'}}>Subtotal: ${favorite.favoriteTotalAmount}</Typography>
    </div>  
  </MobileFavorite>
);

  const renderEmptyFavorite = () => (
    <div style={{display: 'flex', justifyContent: 'center', alignItems: 'center', flexDirection: 'column', height: 'calc(100vh - 64px)'}}>
      <Typography style={{padding: '25px 0'}}>You have no favorite products selected</Typography>
      <img 
      src={emptyFavorite} 
      alt="empty favorite"
      style={{width: '300px', height: '300px', objectFit: 'cover', objectPosition: 'center center'}}
      />
      <Button variant="contained" color="secondary" style={{width: '100px', marginTop: '25px'}} onClick={() => navigate('/')}>Shop</Button>
    </div>
  );



  return (
    <div>
      {!error ?
        (
        !favorite?.favoriteItems?.length ? renderEmptyFavorite() :
        (isXs) ?  renderMobileFavorite() : 
        (isSm) ? renderMobileFavorite() :
          renderDesktopFavorite()
        ) : (
          <Error403></Error403>
        )
      }
    </div>

  );
};

export default Favorite;